import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Subject, takeUntil, throwError } from 'rxjs';
import { AppTokenHandler } from 'src/app/CommonService/app-token-handler';
import { AzureADAuthService } from 'src/app/CommonService/azure-adauth.service';
import { DataService } from 'src/app/CommonService/data.service';
import { ProgressService } from 'src/app/CommonService/progress.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  private _destroying$ = new Subject<void>();
  private azure_token: string = '';
   hostingEnv :string = '';
  constructor(private appToken: AppTokenHandler, private gservice: DataService,
    private authADService: AzureADAuthService,
    private route: Router, private spinnerService: ProgressService) { }
    loading$ = this.spinnerService.loading$;
    IsLoadingResults: any;
    ngOnDestroy(): void {
      this._destroying$.next();
      this._destroying$.complete();
    }
    ngOnInit(): void {
      this.IsLoadingResults = true;
      this.hostingEnv = environment.IsHostingEnvAzure ? 'true' : '';
      if (this.hostingEnv) {
        this.acquireAzureToken();
      }
      else {
        this.GetUserDetails();
      }
    }

    async acquireAzureToken() {
      if (this.appToken.getSessionToken().length <= 0) {
        this.authADService.handleQueryParameters()
          .pipe(
            takeUntil(this._destroying$),
            catchError(error => {
              return throwError(() => error);
            })
          )
          .subscribe({
            next: (result) => {
              if (result) {
                this.azure_token = result;
                this.GetUserDetails();
              }
            },error: (error) => { 

              console.error(error);
            }
          });
      }
      else {
        this.GetUserDetails();
      }
    }
  GetUserDetails() {
    this.IsLoadingResults = true;

    this.appToken.clearSessionToken();
    if (this.appToken.getSessionToken().length <= 0) {
      this.spinnerService.ChangeProgressStatus(true);

      this.gservice.Login('',this.azure_token).subscribe((data: any) => {
    this.IsLoadingResults = false;

        if (data.IsAuthenticated && data.IsConsent == true) {
          this.appToken.setSessionToken(data);
          this.route.navigate(['/home']);
        } else if (data.IsConsent == false) {
          this.appToken.setSessionToken(data);
          this.route.navigate(['/privacyNotice'])
        }
        else {
          this.route.navigate(['/error/1']);
        }
      }
        , (error: Response) => {
          if (error.status <= 0) {
            this.route.navigate(['/error/2']);
          } else if (error.status === 401) {
            this.route.navigate(['/error/1']);
          } else {
            this.route.navigate(['/error/2']);
          }
        }, () => {
          this.spinnerService.ChangeProgressStatus(false);
        });
    } else {
      this.route.navigate(['/home']);
    }
  }

}
